import { atom } from "jotai";
import componentStackAtom from "./componentStackAtom";
import componentStackIdsAtom from "./ComponentStackIdsAtom";
import { requestCurrentStackEntryClose } from "./requestCurrenStackEntryClose";

const resetComponentStackAtom = atom(null, async (get, set) => {
  const canReset = await requestCurrentStackEntryClose(get);

  if (!canReset) {
    return false;
  }

  set(componentStackAtom, []);
  set(componentStackIdsAtom, []);

  return true;
});

export default resetComponentStackAtom;
